import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";
import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";

/**
 * @format custom-hidden
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.Branding)
@ComponentConfigurationClass("branding")
export class BrandingConfiguration {

    public enabled?: boolean;

}
